import React from 'react';
import PropTypes from 'prop-types';
import LinkButton from '../../../../../../components/LinkButton';
import LinkBuilder from '../../../../../../helpers/link-builder';
import {useReviewAction} from '../../../../../../hooks/useReviewAction';

const ReviewsWidgetItem = props => {
  const { user, record } = props;
  const { AllowView, UrlAlias, PublicName, ReviewType, TypeName } = record;

  const { isAllowedView } = useReviewAction(user);

  const handleClick = () => {
    if (isAllowedView({ AllowView, ReviewType, TypeName })) {
      window.open(
        LinkBuilder.getReviewLink(ReviewType, UrlAlias, PublicName),
        '_blank'
      );
    }
  };

  return (
    <div className="sidebar__table-row">
      <div className="sidebar__table-column">
        <LinkButton
          text={record.TitleName}
          controlFunc={handleClick}
          btnFontWeight="600"
          btnFontSize="0.8571rem"
          underline={false}
          btnFontFamily="Noto Sans"
          btnStyles={{
            textAlign: 'left',
          }}
        />
      </div>
      <div className="sidebar__table-column">
        <div className="sidebar__text" style={{ textAlign: 'right' }}>
          {record.DateAdd}
        </div>
      </div>
    </div>
  );
};

ReviewsWidgetItem.propTypes = {
  user: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  record: PropTypes.object.isRequired,
};

export default ReviewsWidgetItem;
